import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const DetailLeftContainer = styled.div<React.CSSProperties>`
  display: flex;
  flex-direction: column;
  position: absolute;
  left: ${136 * Screen.widthRatio}px;
  top: ${542 * Screen.widthRatio}px;
`;

export default DetailLeftContainer;
